import { MultiSelect, type MultiSelectProps } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';

type TenantFilterProps = Omit<MultiSelectProps, 'data' | 'value' | 'onChange'> & {
  tenants: ReadonlyArray<{ subdomain: string; companyName: string }>;
  selectedSubdomains: string[];
  onChange: (subdomains: string[]) => void;
};

export const TenantFilter = ({
  tenants,
  selectedSubdomains,
  onChange,
  ...layout
}: TenantFilterProps) => {
  const { t } = useTranslation();

  return (
    <MultiSelect
      searchable
      clearable
      clearButtonProps={{
        'aria-hidden': false,
        'aria-label': t(i18nKeys.GROUP.CLEAR_FILTER),
        tabIndex: 0,
      }}
      placeholder={t(i18nKeys.GROUP.FILTER_COMPANIES)}
      data={tenants.map(({ subdomain, companyName }) => ({
        value: subdomain,
        label: companyName,
      }))}
      value={selectedSubdomains}
      onChange={onChange}
      comboboxProps={{ keepMounted: false }}
      {...layout}
    />
  );
};
